var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNativeTooling = function SvgNativeTooling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.487,
    cy: 35.869,
    r: 8.715,
    stroke: "currentColor",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m42.22 17.1 5.825.008 15.2 15.84v6.2L48.054 55.013h-5.845L27.006 39.135V33.01L42.219 17.1Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.248 48.922 48.056 64.787h-5.845L27.008 48.909",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.248 58.918 48.056 74.782h-5.845L27.008 58.904",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgNativeTooling;